import {
  BoardMoveIcon,
  BriefcaseIcon,
  ContrastIcon,
  EraserIcon,
  FilePenLineIcon,
  FormIcon,
  LayersIcon,
  LightbulbIcon,
  PaintbrushIcon,
  PaintbrushVerticalIcon,
  PencilIcon,
  ScalingIcon,
  ShoppingBagIcon,
  SparklesIcon,
  SquareRoundCornerIcon,
  StampIcon,
  StoreIcon,
  SummaryIcon,
  TagsIcon,
} from '@air/design-icons';
import { reportErrorToBugsnag } from '@air/utils-error';

import { type WorkspaceAgentIconComponent } from '~/components/v2/components/workspace/workspace-agent-panel/design-system/types';

const WORKSPACE_AGENT_DISPLAY_ICON_BY_NAME: Record<string, WorkspaceAgentIconComponent> = {
  'board-move': BoardMoveIcon,
  briefcase: BriefcaseIcon,
  contrast: ContrastIcon,
  eraser: EraserIcon,
  'file-pen-line': FilePenLineIcon,
  form: FormIcon,
  layers: LayersIcon,
  lightbulb: LightbulbIcon,
  paintbrush: PaintbrushIcon,
  'paintbrush-vertical': PaintbrushVerticalIcon,
  pencil: PencilIcon,
  scaling: ScalingIcon,
  'shopping-bag': ShoppingBagIcon,
  sparkles: SparklesIcon,
  'square-round-corner': SquareRoundCornerIcon,
  stamp: StampIcon,
  store: StoreIcon,
  summary: SummaryIcon,
  tags: TagsIcon,
};

const reportedUnknownIcons = new Set<string>();

export const resolveWorkspaceAgentDisplayIcon = (iconName: string): WorkspaceAgentIconComponent => {
  const icon = WORKSPACE_AGENT_DISPLAY_ICON_BY_NAME[iconName];

  if (icon) {
    return icon;
  }

  if (!reportedUnknownIcons.has(iconName)) {
    reportedUnknownIcons.add(iconName);
    reportErrorToBugsnag({
      context: 'Unknown workspace agent display icon name',
      error: new Error(`Unknown workspace agent display icon: ${iconName}`),
    });
  }

  return SummaryIcon;
};
